import axios from 'axios';
import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { THEME_COLORS } from "../common/colors";

const VerifiedTitle = styled.h1`
    text-align: center;
    margin: 20px;
    color: ${THEME_COLORS.primaryHover};
`;

const UserValidation = ({ computedMatch }) => {
  const { token } = computedMatch.params;
  axios
    .get(
      `${process.env.REACT_APP_PUBLIC_API_URL}/validation/newaccount/${token}`,
      {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      },
    )
    .then(data => {
      if (data.data.success) {
        window.location = '/?message=user_validated';
      } else {
        window.location = '/?message=user_not_validated';
      }
    });
  return <VerifiedTitle>You have been verified! You will be redirected soon...</VerifiedTitle>;
};

UserValidation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  computedMatch: PropTypes.object.isRequired,
};

export default UserValidation;
